import React, { Component } from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import Paper from 'material-ui/Paper';
import FontIcon from 'material-ui/FontIcon';


class BuildListItem extends Component {
    constructor(props) {
        super(props);
        this.state = { paper_width: 200, build: props.build, config: props.config }
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    }

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions.bind(this));
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions.bind(this));
    }

    updateWindowDimensions() {
        this.setState({ paper_width: window.innerWidth });
    }

    getiOSInstallButton = (styles, config, build, plistName) => {
        let appUrl = `${config.BucketUrl}${config.Prefix}${build.buildNumber}/${plistName ? plistName : config.PlistName}`;
        if (config.Template === "iOS")
            return <RaisedButton
                label={plistName ? plistName.substring(0,plistName.indexOf(".")) : "Install"}
                style={styles.button}
                primary={true}
                href={`${config.iOSInstallUrl}${appUrl}`}
                icon={<FontIcon className="material-icons">system_update</FontIcon>} />
    }

    getBuildInfo = (build,config) => {
        return(<div>
            <span className="build-paper-header">Build #{build.buildNumber}     {build.builds}</span>
            <span>   </span>
            <a href={config.ChangeLogUrl}>Change Log</a>
            <br />
            <span className="build-paper">{build.buildTime}</span>
        </div>
        )
    }

    getDownloadButton = (styles,config,build, label = 'Download', appName) => {
        return(<RaisedButton
            label={label}
            style={styles.button}
            primary={true}
            href={`${config.BucketUrl}${config.Prefix}${build.buildNumber}/${appName ? appName : config.AppName}`}
            icon={<FontIcon className="material-icons">cloud_download</FontIcon>}            
        />
        )
    }

    render() {
        let { paper_width, build, config } = this.state;
        
        let styles = {
            button: {
                marginTop: 15,
                marginLeft: 10,

            },
            paper: {
                width: paper_width - 40,
                padding: 10,
                //height: 120,
                margin: 10,
                display: 'inline-block',
            }
        };
        if(config.Prefix.toLowerCase().includes('pavarotti/firmware')){   
            let oldDate = new Date('2018-09-01');            
            // To display separate release and dev builds
            if(new Date(build.buildTime) > oldDate){                
                return (                
                    <div>
                        <Paper width={window.innerWidth} style={styles.paper} zDepth={1}>
                            <div>
                                {this.getBuildInfo(build,config)}
                                {this.getDownloadButton(styles,config,build,'Firmware','harmony-image-pavarotti-' + build.builds +'-'+ build.buildNumber +'.hfw2')}                            
                                {this.getDownloadButton(styles,config,build,'Zip','harmony-image-pavarotti-'+ build.builds +'-'+ build.buildNumber + '.zip')}
                                {this.getDownloadButton(styles,config,build,'Mfg','harmony-image-pavarotti-'+ build.builds +'-'+ build.buildNumber + '.mfg')}
                              
                            </div>
                        </Paper>
                    </div>
                )
            }
            else{
                return (                
                    <div>
                        <Paper width={window.innerWidth} style={styles.paper} zDepth={1}>
                            <div>
                                {this.getBuildInfo(build,config)}
                                {this.getDownloadButton(styles,config,build,'Firmware','harmony-image-pavarotti-'+ build.buildNumber +'.hfw2')}                            
                                {this.getDownloadButton(styles,config,build,'Zip','harmony-image-pavarotti-'+ build.buildNumber + '.zip')}
                                {this.getDownloadButton(styles,config,build,'Mfg','harmony-image-pavarotti-'+ build.buildNumber + '.mfg')}
                               
                            </div>
                        </Paper>
                    </div>
                )
            }
            
        } else
        if(config.Prefix.toLowerCase().includes('pavarotti/ios')){
            //styles.paper.height = 180;
            return (
                <div>
                    <Paper width={window.innerWidth} style={styles.paper} zDepth={1} height = {240}>
                        <div>
                            {this.getBuildInfo(build,config)}
                            {this.getDownloadButton(styles,config,build,'Pavarotti-DEV','Pavarotti-DEV.ipa')}
                            {this.getDownloadButton(styles,config,build,'Pavarotti-AUTO','Pavarotti-AUTO.ipa')} 
                            {this.getDownloadButton(styles,config,build,'Pavarotti-INT','Pavarotti-INT.ipa')} 
                            {this.getDownloadButton(styles,config,build,'Pavarotti-STG','Pavarotti-STG.ipa')} 
                            {this.getDownloadButton(styles,config,build,'Pavarotti-BETA','Pavarotti-BETA.ipa')}
                            {this.getDownloadButton(styles,config,build,'Pavarotti-PROD','Pavarotti-PROD.ipa')} 
                            <br/>
                            {this.getiOSInstallButton(styles, config, build,'Pavarotti-DEV.plist')}
                            {this.getiOSInstallButton(styles, config, build,"Pavarotti-AUTO.plist")}
                            {this.getiOSInstallButton(styles, config, build,"Pavarotti-INT.plist")}    
                            {this.getiOSInstallButton(styles, config, build,"Pavarotti-STG.plist")}    
                            {this.getiOSInstallButton(styles, config, build,"Pavarotti-BETA.plist")}
                            {this.getiOSInstallButton(styles, config, build,"Pavarotti-PROD.plist")}    
                        </div>
                    </Paper>
                </div>
            )
        } else
        if(config.Prefix.toLowerCase().includes('pavarotti/android')){
            return (
                <div>
                    <Paper width={window.innerWidth} style={styles.paper} zDepth={1}>
                        <div>
                            {this.getBuildInfo(build,config)}
                            {this.getDownloadButton(styles,config,build,'Dev','pavarotti-dev.apk')}

                            {this.getDownloadButton(styles,config,build,'Auto','pavarotti-auto.apk')}
                            
                            {this.getDownloadButton(styles,config,build,'Int','pavarotti-int.apk')}
                           
                            {this.getDownloadButton(styles,config,build,'Beta','pavarotti-beta.apk')}
                                                 
                            {this.getDownloadButton(styles,config,build,'Stg','pavarotti-staging.apk')}
                            
                            {this.getDownloadButton(styles,config,build,'Prod','pavarotti-prod.apk')}
                                                                                               
                        </div>
                    </Paper>
                </div>
            )
        }
        else if(config.Header.toLowerCase().includes('goldmw')){
            return (
                <div>
                    <Paper width={window.innerWidth} style={styles.paper} zDepth={1}>
                        <div>
                            {this.getBuildInfo(build,config)}
                            {this.getDownloadButton(styles,config,build,'LogitechHarmonyRemote','LogitechHarmonyRemoteSoftware.dmg')}
                                                                                               
                        </div>
                    </Paper>
                </div>
            )

        }        
        else{
            return (
                <div>
                    <Paper width={window.innerWidth} style={styles.paper} zDepth={1}>
                        <div>
                            {this.getBuildInfo(build,config)}
                            {this.getDownloadButton(styles,config,build)}
                            {this.getiOSInstallButton(styles, config, build)}                            
                        </div>
                    </Paper>
                </div>
            )

        }        
    }

}

export default BuildListItem;


// WEBPACK FOOTER //
// ./src/components/build-list-item.js